// Shared ECharts core for the Sales-dashboard chart migration
// (docs/michael/TASK-echarts-migration.md in the backend repo).
// Register only what the migrated charts actually use — keeps the bundle lean.
// When migrating a new chart type, add its module here (LineChart,
// DataZoomComponent, ...) rather than importing "echarts" whole.
import * as echarts from "echarts/core";
import { PieChart, BarChart, LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  PieChart,
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  MarkLineComponent,
  CanvasRenderer,
]);

export default echarts;
